<template>
  <header id="main-header" class="main-header">
    <nav
      class="
        main-nav
        container
        navbar navbar-expand-md navbar-light
        flex-nowrap
      "
      :class="[{ mobileActive: navbarMobileVisible }]"
    >
      <router-link to="/" class="navbar-brand ">
        <img
          src="@/assets/images/logo-boticario.png"
          :alt="'Logotipo ' + $store.state.websiteName"
          :title="$store.state.websiteName"
        />
      </router-link>

      <button
        class="
          hamburger hamburger--slider
          navbar-toggle
          d-lg-none d-xm-block
          ml-auto
        "
        type="button"
        :class="{ 'is-active': navbarMobileVisible }"
        @click="toggleMenu"
      >
        <span class="hamburger-box">
          <span class="hamburger-inner"></span>
        </span>
      </button>

      <ul class="d-none d-lg-flex navbar-nav align-items-center justify-content-end flex-grow-1">
        <div class="d-flex align-items-center">
          <li class="nav-item d-none d-lg-flex">
            <router-link to="/#sobre" class="nav-link">SOBRE NÓS</router-link>
          </li>

          <li class="nav-item d-none d-lg-flex">
            <router-link to="/#programa" class="nav-link">O PROGRAMA</router-link>
          </li>

          <li class="nav-item d-none d-lg-flex">
            <router-link to="/#requisitos" class="nav-link">REQUISITOS</router-link>
          </li>

          <li class="nav-item d-none d-lg-flex">
            <router-link to="/#areas" class="nav-link">ÁREAS</router-link>
          </li>

          <li class="nav-item d-none d-lg-flex">
            <router-link to="/#faq" class="nav-link">FAQ</router-link>
          </li>

          <li class="nav-item d-none d-lg-flex ml-3">
            <router-link :to="'/vagas/' + $store.state.bancoDeTalentos + '/inscricao'" class="nav-link btn btn-color-1 py-2 px-4 text-white">INSCREVA-SE</router-link>
          </li>
        </div>

      </ul>

      <ul class="navbar-nav navbar-mobile d-flex d-lg-none">
        <span class="navbar-mobile-bg" @click="toggleMenu"></span>

        <li class="nav-item">
          <router-link
            to="/#sobre"
            class="nav-link"
            @click.native="navbarMobileVisible = false"
            >SOBRE NÓS</router-link
          >
        </li>

        <li class="nav-item">
          <router-link
            to="/#programa"
            class="nav-link"
            @click.native="navbarMobileVisible = false"
            >O PROGRAMA</router-link
          >
        </li>

        <li class="nav-item">
          <router-link
            to="/#requisitos"
            class="nav-link"
            @click.native="navbarMobileVisible = false"
            >REQUISITOS</router-link
          >
        </li>

        <li class="nav-item">
          <router-link
            to="/#areas"
            class="nav-link"
            @click.native="navbarMobileVisible = false"
            >ÁREAS</router-link
          >
        </li>

        <li class="nav-item">
          <router-link
            to="/#faq"
            class="nav-link"
            @click.native="navbarMobileVisible = false"
            >FAQ</router-link
          >
        </li>

        <li class="nav-item px-3">
          <router-link :to="'/vagas/' + $store.state.bancoDeTalentos + '/inscricao'" class="nav-link btn btn-color-1  py-2 px-4 ">
            <span class="text-white">INSCREVA-SE</span>
          </router-link>
        </li>

        <li class="nav-item" v-if="this.$store.state.user.isAuth">
          <a href="#" class="nav-link" @click="signOut"
            >Sair</a
          >
        </li>
      </ul>
    </nav>
  </header>
</template>

<script>
  import "@/components/icons/search";
  import "@/components/icons/linkedin";
  import "@/components/icons/facebook";
  import PersonalDataIcon from "@/components/mlIcons/PersonalData";
  import PencilIcon from "vue-material-design-icons/Pencil.vue";
  import FileCheckOutlineIcon from "@/components/mlIcons/FileCheckOutline";

  export default {
    name: "mainHeader",

    components: {
      PersonalDataIcon,
      PencilIcon,
      FileCheckOutlineIcon,
    },

    data() {
      return {
        primaryBackground: false,
        scrolled: false,
        isTop: false,
        navbarMobileVisible: false,
      };
    },

    computed: {
      firstName() {
        if(this.$store.state.user){
          const profile = this.$store.state.user.profile;
          const socialName = profile.socialName;
          const name = profile.name.split(' ')[0];
          if(socialName){
            return socialName;
          } else if(window.signUp){
            return null
          } else if(name){
            return name;
          }
        }

        return null;
      },

      avatar() {
        return this.$store.state.user.profile.avatar;
      },
    },

    mounted() {
      this.handleScroll();
      window.addEventListener("scroll", this.handleScroll);
    },

    watch: {
      $route(to, from) {
        this.handleScroll();
      },
    },

    methods: {
      sendToLogin() {
        this.$store.commit("user/SET_NEXT_ROUTE", { path: "/vagas" });
        this.$store.commit("DEVISE_FORM", "login");
      },

      handleScroll(event) {
        let routeName = this.$route.name;
        let scrolledAfter = 150;
        let scrollY = window.scrollY || window.pageYOffset;
        this.scrolled =
          scrollY > scrolledAfter ||
          routeName == "job" ||
          routeName == "ficha" ||
          routeName == "testes" ||
          routeName == "capa-teste" ||
          routeName == "teste" ||
          routeName == "pending-tests" ||
          routeName == "terms";

        this.isTop =
          scrollY < 30 &&
          !(
            routeName == "ficha" ||
            routeName == "testes" ||
            routeName == "capa-teste" ||
            routeName == "teste"
          );
      },

      signOut() {
        this.$store.dispatch("user/signOut");
        if (this.$route.meta.requiresAuth) this.$router.push("/");
      },

      toggleMenu() {
        this.navbarMobileVisible = !this.navbarMobileVisible;
      },

      changeModal(target) {
        this.$store.commit("DEVISE_FORM", target);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .dropdown-item {
    padding: 8px 20px;

    &:not(:last-child) {
      font-weight: 500;
      color: theme-color("color-6");
    }

    .material-design-icon {
      font-size: 1.3rem;
    }

    &.active,
    &:active,
    &:hover,
    &:focus {
      background: white;
    }
  }

  .main-header {
    padding: 25px 15px;
    background: white;
    box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.15);
    position: sticky;
    top: 0;
    z-index: 20;

    &.secondaryBackground {
      background-image: linear-gradient(
        theme-color("header-primary-background") 100%,
        transparent
      );
    }

    .navbar-brand {
      margin: 0;
      padding: 0;

      img {
        max-height: 58px;
      }
    }

    .main-nav {
      transition: padding 0.2s ease-in-out;
      max-width: inherit;
      &.container {
        width: inherit;
      }

      &.mobileActive {
        .navbar-mobile {
          transform: translateX(0vw);

          .navbar-mobile-bg {
            opacity: 1;
            visibility: visible;
          }
        }
      }

      .navbar-nav > div {
        display: flex;
        justify-content: space-between;

        .nav-link{
          font-weight: 500;
          font-size: 16px;
          padding: 0 20px;
          color: #000000;
        }
      }

      @include media-breakpoint-down(lg) {
        &.container {
          .navbar-nav {
            align-items: center;
            text-align: center;
          }
        }
      }

    }

    .navbar-mobile {
      .navbar-mobile-bg {
        display: none;
      }

      @include media-breakpoint-down(md) {
        width: 290px;
        position: fixed;
        left: 0;
        top: 0;
        height: 100%;
        background: #fff;
        z-index: 10;
        transform: translateX(-100vw);
        transition: transform 0.3s ease-in-out;
        flex-direction: column !important;

        .nav-item {
          width: 100%;

          &.active {
            .nav-link {
              background-color: theme-color("color-1") !important;
              border-bottom: none !important;
            }
          }

          .nav-link {
            color: $body-color !important;
            padding: 1rem !important;
            font-weight: 400 !important;
            text-transform: capitalize !important;
            text-align: left;
            &:hover {
              background-color: theme-color("color-1") !important;
            }
          }
        }

        .navbar-mobile-bg {
          display: block;
          width: 200vw;
          height: 100%;
          position: fixed;
          left: 290px;
          right: 0;
          background: rgba(0, 0, 0, 0.5);
          opacity: 0;
          visibility: hidden;
          transition: opacity 0.2s ease-in-out 0.1s, visibility 0.01s linear;
        }
      }
    }
  }

  .hamburger {
    width: 38px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    background-color: theme-color("color-1");
    .hamburger-box {
      width: 18px;
      .hamburger-inner {
        width: 100%;
        height: 1.5px;
        border-radius: 10px;
        background-color: #fff;
        &::before {
          top: -7px;
        }
        &::after {
          bottom: -7px;
        }
        &::before, &::after {
          width: 100%;
          height: 1.5px;
          border-radius: 10px;
          background-color: #fff;
        }
      }
    }
  }
</style>
